import React, { Component } from 'react';



import EditGoodsForm from '../components/EditGoodsForm';


import { translations } from '../i18n/translations';

export default class PolicyGoodsTable extends Component{

    constructor(props){
        super(props);

        this.state = {
            currency_rate: {},
            selected_goods: [],
            sections_list: [],
            show_goods_form: true
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            currency_rate: nextProps.currency_rate,
            sections_list: nextProps.sections_list,
            show_goods_form: nextProps.show_goods_form,
            selected_goods: nextProps.selected_goods
        })
    }

    render(){

        let { 
            selected_goods,
            currency_rate,
            sections_list,
            show_goods_form 
        } = this.state;


        return(
            <div className="clearfix">
                <EditGoodsForm 
                    currency_rate={ currency_rate }
                    sections_list={ sections_list }
                    show_goods_form={ show_goods_form }
                    addGoodsFn={ this.props.addGoodsFn }
                    removeGoodsFn={ this.props.removeGoodsFn } />

                { 
                    selected_goods ? 
                
                    <table className="table table-bordered goods-table">
                    <thead>
                        <tr>
                            <th width="50%">{ translations.goods }</th>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Units</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            selected_goods.map((good, index) => {
                                return (
                                    <tr key={ index }>
                                        <td><span className="text-success">{ good.section_name }</span></td>
                                        <td><span className="text-success">{ good.description }</span></td>
                                        <td><span className="text-success">{ good.quantity }</span></td>
                                        <td><span className="text-success">{ good.unit_qty }</span></td>
                                        <td>
                                            <span 
                                                className="label label-danger label-btn" 
                                                onClick={ ()=> { this.props.removeGoodsFn(good) } }>
                                                <i className="icon ion-close-round"></i>
                                            </span>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                    </table>
                :
                    <div className="alert alert-danger">{ translations.no_goods_added }</div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PolicyGoodsTable.jsx